import React from 'react';
import { Layout as AntLayout, Switch } from 'antd';
import styled from 'styled-components';
import { BulbOutlined } from '@ant-design/icons';

const { Header, Content } = AntLayout;

const StyledLayout = styled(AntLayout)`
  min-height: 100vh;
`;

const StyledHeader = styled(Header)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 24px;
`;

const StyledContent = styled(Content)`
  padding: 24px;
  margin: 24px;
  background: ${props => props.theme.isDarkMode ? '#141414' : '#ffffff'};
`;

interface LayoutProps {
  children: React.ReactNode;
  isDarkMode: boolean;
  onThemeChange: (checked: boolean) => void;
}

const Layout: React.FC<LayoutProps> = ({ children, isDarkMode, onThemeChange }) => {
  return (
    <StyledLayout>
      <StyledHeader>
        <h1 style={{ color: '#fff', margin: 0 }}>Excel Merger</h1>
        <Switch
          checkedChildren={<BulbOutlined />}
          unCheckedChildren={<BulbOutlined />}
          checked={isDarkMode}
          onChange={onThemeChange}
        />
      </StyledHeader>
      <StyledContent>
        {children}
      </StyledContent>
    </StyledLayout>
  );
};

export default Layout; 